<template>
  <modal
    name="yagioffer-special-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeDialog"
        icon="el-icon-close"
        type="text"
      ></el-button>
    </div>

    <div id="yagioffer_quickemail_popup">
      <div style="text-align: center">
        <div>
          <div>
            <!-- SP 端末保存フロー中は動的文言、通常は固定 -->
            <p
              v-if="spDownloadStatusLabel != null"
              style="font-weight: bold; font-size: 1.2rem"
            >
              {{ spDownloadStatusLabel }}
            </p>
            <p v-else style="font-weight: bold; font-size: 1.2rem">
              ダウンロードが完了しました！！
            </p>
            <p>
              <img
                src="/static/renew2_img/img_yagioffer_title.png"
                alt="貴社と履歴書を作成したユーザーの出会いを祝して、Yagishで運営している採用サービスのキャンペーンをご案内します！"
                style="width: 80%"
              />
            </p>

            <!--<p style="margin: 10px auto 20px; font-weight: bold;"><img src="/static/renew2_img/yagioffer_logo.png" alt="ヤギオファー,yagioffer" style="width: 120px; height: auto;"><br class="sp">使ってみませんか？</p>-->
          </div>
          <div>
            <!--<p style="font-size: 1rem; font-weight: bold; line-height: 1.2;">130万人のユーザーにオファーができ、<br class="sp">1万円で2名採用<br>
                      <span style="font-size: 0.9rem;">できた実績がある スカウトサービスです</span></p>-->
            <p>
              <img
                src="/static/renew2_img/img_point.png"
                alt="130万人のユーザーにオファーができ、できた実績があるスカウトサービスです"
                style="width: 80%; padding: 5px 20px 20px"
              />
            </p>

            <p
              style="
                color: #e95b10;
                font-size: 1.4rem;
                font-weight: bold;
                line-height: 1.2;
              "
            >
              <span style="font-size: 1rem">＼新規登録キャンペーン／</span
              ><br />100人に無料で<br class="sp" /><span
                style="font-size: 1.2rem"
                >採用のスカウトを送れる！</span
              >
            </p>
            <el-button
              style="
                background: #e95b10;
                border-radius: 50px;
                padding: 15px;
                font-size: 1.4rem;
                color: #fff;
                font-weight: bold;
                width: 320px;
                margin: 5px auto;
              "
              @click="sendYagiofferSpecialEmail()"
              v-if="!isSended"
              >無料コードをもらう<img
                src="/static/renew2_img/icon_mail.svg"
                alt="メールで無料コードをもらう"
            /></el-button>
            <el-button
              style="
                background: #0f9934;
                border-radius: 50px;
                padding: 15px;
                font-size: 1.4rem;
                color: #fff;
                font-weight: bold;
                width: 320px;
                margin: 5px auto;
              "
              @click="closeDialog()"
              v-else
              >送信しました<img
                src="/static/renew2_img/icon_mail.svg"
                alt="メールで無料コードをもらう"
            /></el-button>

            <ul style="font-size: 0.7rem; text-align: left">
              <li>※メールで無料コードが届きます。</li>
              <li>
                ※登録時に支払い方法を【キャンペーンコード】を選択し、無料コードを入力してください。
              </li>
              <li>※登録後72時間無料でお試しいただけます。</li>
            </ul>
          </div>
          <div style="text-align: right; font-size: 0.8rem">
            <a
              href="https://yagioffer.yagish.jp/partner-landing/p2"
              target="_blank"
              style="color: #e3165c"
              ><img
                src="/static/renew2_img/icon_question.svg"
                alt="ヤギオファーとは？"
              />ヤギオファーとは</a
            >
          </div>
        </div>

        <!--注意事項-->
        <div
          style="
            background: #eff8f8;
            padding: 20px;
            margin: 15px 0;
            height: 20vh;
            border-radius: 10px;
            text-align: left;
            overflow: scroll;
          "
        >
          <div>
            <h5>対象</h5>
            <p style="font-size: 0.8rem">
              新規企業様限定<br />
              ※利用登録履歴がある企業様は対象外となります。
            </p>
          </div>
          <div style="margin-top: 10px">
            <h5>注意点</h5>
            <ul
              style="
                font-size: 0.8rem;
                list-style-type: disc;
                margin-left: 20px;
              "
            >
              <li>
                キャンペーンコードの利用期限は、上記利用ステップ②を完了後72時間です。
              </li>
              <li>
                72時間の間、人材検索・オファー送信（100通まで）が自由に利用可能です。
              </li>
              <li>
                72時間の間にオファーを受信したユーザーがオファーを承諾した場合、利用期限が切れるまでチャット機能や、履歴書に記載の電話番号等への直接アプローチが可能です。
              </li>
              <li>
                上記期限が過ぎた後にユーザーからオファー承諾やメッセージが来た場合、メールで通知が来ます。
              </li>
              <li>
                利用期限が過ぎた後に連絡を希望する場合は、利用中のカテゴリーで10,000円(税別)を追加課金することで、引き続きyagiofferをご利用いただけます。
              </li>
            </ul>
          </div>
        </div>
        <!--<div>
              <p>Yagishの<a href="https://rirekisho.yagish.jp/terms">利用規約</a>、<a href="https://www.yagish.jp/privacy/">個人情報保護方針</a></p>
              <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a">プライバシーポリシー</a></p>
              <p><img src="/static/renew2_img//static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して応募する</p>
          </div>-->
        <!--</a></div><img src="/static/renew2_img//static/renew2_img/bnr/joblist_popup_bottom_banner20230607.png"
              alt="ここまで書いたあなたはスゴいッ！えらいッ！">-->
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { computed } from 'vue'
import { usePdfDownloadState } from '@/composables/usePdfDownloadState'
export default {
  components: {},
  setup() {
    const { isPdfDownloading, isSpDownloadMode } = usePdfDownloadState()
    /** SP 端末保存フロー中の動的タイトル（null = 通常フロー） */
    const spDownloadStatusLabel = computed(() => {
      if (!isSpDownloadMode.value) return null
      return isPdfDownloading.value
        ? 'ダウンロードの準備をしています。'
        : 'ダウンロードの準備ができました！'
    })
    return { spDownloadStatusLabel }
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      gradeYear: 0,
      history_id: 0,
      isSended: false,
      fullscreenLoading: false,
      username: ''
    }
  },
  created: function () {},
  computed: {},
  methods: {
    openYagiofferSpecialDialog: function (history_id) {
      return
      this.history_id = history_id
      this.$modal.show('yagioffer-special-dialog')
      const app = this
      // app.isSended = false
      const formData = new FormData()
      formData.append('uuid', '-')
      formData.append('format_id', history_id)
      formData.append('dialog_name', 'yagioffer_special_dialog')
      formData.append('permission_type', 1)
      formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      app.$axios.post(app.$varuna.endPoints.displayDialog, formData, {
        timeout: 60000
      })
    },
    closeDialog: function () {
      this.$modal.hide('yagioffer-special-dialog')
    },
    sendYagiofferSpecialEmail: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('history_id', app.history_id)
      formData.append('uuid', '-')
      this.$axios
        .post(this.$varuna.endPoints.sendYagiofferCampaign, formData, {
          timeout: 60000
        })
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '無料コードをメールに送りました。',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on(
      'open-yagioffer-special-dialog',
      this.openYagiofferSpecialDialog
    )
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off(
      'open-yagioffer-special-dialog',
      this.openYagiofferSpecialDialog
    )
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
